import type { Store } from "@/types/content";

export const storesPart2: Store[] = [
  {
    id: "svc-5",
    slug: "taipei-eyebrow-studio",
    name: "Brow Atelier 霧眉工作室",
    description: "專注半永久紋繡的精品工作室，以韓式霧眉和飄眉為核心服務。師傅從業超過 8 年，曾赴韓國研修最新技法。採用符合食藥署規範的進口色料，安全性有保障。每位客人術前都會進行 30 分鐘的臉型分析與設計溝通，確保眉形符合個人特質。提供術後 2 個月免費補色服務。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_b5ea03948f261ebea42528e42d3e534e_e8c053a3.jpg",
    category: "霧眉",
    tags: ["霧眉", "飄眉", "半永久紋繡", "韓式", "大安區"],
    priceRange: "$6,000 - $12,000",
    location: "台北市大安區信義路三段 160 號 6F",
    rating: 4.8,
    reviewCount: 312,
    features: ["30分鐘設計溝通", "2個月免費補色", "符合食藥署規範色料", "術後護理說明", "作品可追蹤"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>Brow Atelier 是台北大安區最受推薦的霧眉工作室之一。師傅從業超過 8 年，曾赴首爾研修最新韓式半永久技法。與其他店家最大的不同是——術前設計溝通時間長達 30 分鐘，這段時間用來了解你的臉型、膚色、慣用妝感和職業特性，確保做出來的眉形真的適合你。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-user-search-line", title: "術前設計溝通扎實 ✓", description: "神秘客測試：設計溝通長達 35 分鐘，師傅從臉型骨架到習慣妝感都問到了" },
          { _key: "f2", icon: "ri-palette-line", title: "顏色自然不誇張 ✓", description: "選色保守而精準，做完 1 個月後退色也是自然感，不會變出奇怪的顏色" },
          { _key: "f3", icon: "ri-flask-line", title: "色料安全可追溯 ✓", description: "師傅主動提供色料品牌與成分資訊，符合食藥署美容色料規範" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "霧眉常見問題",
        items: [
          { _key: "q1", question: "霧眉可以維持多久？", answer: "依膚質而定，一般可維持 1.5-3 年。出油肌代謝快，維持約 1.5 年；乾燥肌可維持到 3 年。術後 2 個月需補色一次，讓顏色更穩定。" },
          { _key: "q2", question: "霧眉做完可以化妝嗎？", answer: "術後 7-10 天為修復期，建議不要化妝在眉毛上。修復後每天可正常化妝，但卸妝時避免過度摩擦眉毛部位。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整霧眉評比",
        subtitle: "神秘客公正評比台北霧眉工作室，帶你找到最自然安全的選擇",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "Brow Atelier 霧眉工作室｜台北大安區霧眉評比",
      description: "台北大安區霧眉評比！韓式技法師傅，設計溝通扎實，2個月免費補色。4.8 星 312 則評價。",
      keywords: ["台北霧眉", "霧眉推薦", "半永久紋繡", "韓式霧眉"],
    },
  },
  {
    id: "svc-6",
    slug: "taipei-iwatens-center",
    name: "岩盤浴療癒中心",
    description: "位於台北大安區的專業岩盤浴場所，引進日本進口天然礦石板，經遠紅外線儀器測試確認效果。提供獨立包廂設計的岩盤浴療程，溫度精準控制在 42-45 度之間，確保每次體驗都能達到深層排汗與促進循環的效果。療程後提供草本茶點與休息區，讓身體在溫熱後慢慢回到平衡狀態。",
    coverImage: "https://readdy.ai/api/search-image?query=Japanese%20iwatens%20hot%20stone%20bed%20spa%20room%20warm%20infrared%20healing%20stones%20therapeutic%20wellness%20environment%20calm%20minimalist%20interior%20simple%20background%20photography&width=1200&height=630&seq=406&orientation=landscape",
    category: "岩盤浴",
    tags: ["岩盤浴", "排毒", "遠紅外線", "溫熱療法", "大安區"],
    priceRange: "$800 - $2,500",
    location: "台北市大安區敦化南路一段 200 號 B1",
    rating: 4.8,
    reviewCount: 312,
    features: ["日本進口礦石板", "溫度精準控制", "獨立包廂", "草本茶點", "遠紅外線測試"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>岩盤浴療癒中心位於台北東區巷弄內的地下室空間，是一間專注於岩盤浴溫熱療法的精品養生會館。從一踏入就能感受到與外界喧囂截然不同的寧靜氛圍——柔和的音樂、淡淡的草本香氣、以及溫熱空氣中透出的放鬆感。</p><p>這次神秘客體驗了 60 分鐘岩盤浴療程，從迎賓花茶到療程後的養生輕食，每個細節都感受到店家對溫熱療法的專業與用心。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-door-closed-line", title: "獨立包廂設計 ✓", description: "每間療程室皆為獨立空間，確保隱私與寧靜，不受外界干擾" },
          { _key: "f2", icon: "ri-temp-hot-line", title: "溫度精準控制 ✓", description: "石板溫度全程維持 42-45 度，不忽冷忽熱，確保遠紅外線效果穩定" },
          { _key: "f3", icon: "ri-cup-line", title: "療程後茶點 ✓", description: "提供草本花茶與養生輕食，幫助身體在溫熱後補充水分與能量" },
          { _key: "f4", icon: "ri-shield-check-line", title: "遠紅外線效果驗證 ✓", description: "使用經儀器測試的日本進口天然礦石板，確保遠紅外線釋放效果" },
        ],
      },
      {
        _type: "faq",
        _key: "faq",
        title: "常見問題",
        items: [
          { _key: "q1", question: "需要提前多久預約？", answer: "建議至少提前 3-5 天預約，週末時段較熱門，建議提前一週。" },
          { _key: "q2", question: "岩盤浴前需要注意什麼？", answer: "建議提前洗澡並去除身上乳液或保養品；空腹不建議進行；有心血管疾病或懷孕者請先諮詢醫師。" },
          { _key: "q3", question: "多久做一次岩盤浴比較好？", answer: "一般保養建議每週 1-2 次；初次體驗建議從 30 分鐘開始，習慣後可延長至 60 分鐘。療程後多喝水，幫助代謝廢物排出。" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整評比報告",
        subtitle: "美好時光指南神秘客公正評比，帶你了解這間店的真實水準",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "岩盤浴療癒中心｜台北大安區岩盤浴評比",
      description: "台北大安區岩盤浴評比！日本進口天然礦石板，溫度精準控制，獨立包廂設計。4.8 星 312 則評價。",
      keywords: ["台北岩盤浴", "大安區岩盤浴", "岩盤浴推薦", "排毒溫熱療法"],
    },
  },
  {
    id: "svc-7",
    slug: "taipei-facial-studio",
    name: "美肌做臉中心",
    description: "大安區頗受好評的專業皮膚管理工作室，專注於客製化做臉與皮膚護理。從基礎深層清潔到高階護理，所有療程都建立在精準的皮膚檢測之上。引進韓國原廠皮膚分析儀器，能清楚呈現肌膚底層狀態，再針對不同膚質設計專屬療程。最讓客人安心的是全程無推銷壓力，美容師只給保養建議，不強迫購買產品。",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20beauty%20clinic%20with%20professional%20skin%20analysis%20equipment%20clean%20white%20interior%20soft%20lighting%20facial%20treatment%20skincare%20therapy%20simple%20background%20photography%20elegant%20calming&width=1200&height=630&seq=407&orientation=landscape",
    category: "做臉",
    tags: ["做臉", "皮膚管理", "清潔", "保養", "大安區"],
    priceRange: "$1,500 - $5,000",
    location: "台北市大安區復興南路一段 280 號 3F",
    rating: 4.6,
    reviewCount: 234,
    features: ["皮膚檢測", "客製化療程", "無推銷", "預約制", "療程後建議"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>美肌做臉中心是大安區頗受好評的皮膚管理工作室。最大的特色是<strong>無推銷壓力</strong>——做完療程，美容師只會給保養建議，不會強迫你買產品或加購課程。每次療程前都會用皮膚分析儀確認當日膚況，針對性地調整療程內容。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-scan-line", title: "皮膚檢測扎實 ✓", description: "每次療程前使用韓國儀器分析水分、油脂、色素分布，不是一套 SOP 走天下" },
          { _key: "f2", icon: "ri-checkbox-circle-line", title: "無推銷 ✓", description: "神秘客測試：做完全程未被推銷任何課程或產品，這在台灣美容市場很難得" },
          { _key: "f3", icon: "ri-star-line", title: "療程效果一致 ✓", description: "多次回訪測試，每次療程完成度穩定，不因不同助理師傅而有明顯品質差異" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整做臉評比",
        subtitle: "神秘客公正評比台北皮膚管理工作室，帶你找到最有效的做臉選擇",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "美肌做臉中心｜台北大安區皮膚管理評比",
      description: "台北大安區做臉評比！皮膚檢測客製化療程，全程無推銷壓力。4.6 星 234 則評價。",
      keywords: ["大安區做臉", "皮膚管理", "做臉推薦", "台北美容"],
    },
  },
  {
    id: "svc-8",
    slug: "taipei-tarot-studio",
    name: "月光塔羅工作室",
    description: "位於台北東區的塔羅與身心靈諮詢工作室，由擁有 10 年以上解讀資歷的塔羅師主持。工作室以「賦能解讀」為核心理念——讓客人帶著更多清晰感和行動力離開，而非製造焦慮。提供單張牌、關係牌陣、年度牌陣等多種解讀服務，也有線上諮詢選項。絕不推銷靈性商品或附加課程。",
    coverImage: "https://readdy.ai/api/search-image?query=Mystical%20tarot%20card%20reading%20studio%20with%20beautiful%20tarot%20deck%20candles%20crystals%20and%20incense%20intimate%20spiritual%20consultation%20space%20warm%20ambient%20lighting%20simple%20background%20photography&width=1200&height=630&seq=408&orientation=landscape",
    category: "塔羅",
    tags: ["塔羅", "身心靈", "占卜", "東區", "線上諮詢"],
    priceRange: "$1,500 - $3,500 /次",
    location: "台北市大安區忠孝東路四段 216 號 5F",
    rating: 4.7,
    reviewCount: 189,
    features: ["10年資歷", "賦能解讀", "不推銷", "線上諮詢", "多種牌陣"],
    content: [
      {
        _type: "richText",
        _key: "intro",
        content: "<p>月光塔羅工作室是台北東區口碑最好的塔羅諮詢場所之一。工作室的核心理念是「賦能」——好的塔羅師不應該讓你帶著更多焦慮離開，而是讓你帶著更多對自己的了解、更清晰的選擇方向離開。</p>",
      },
      {
        _type: "featureList",
        _key: "features",
        title: "評比發現",
        features: [
          { _key: "f1", icon: "ri-heart-3-line", title: "解讀品質高 ✓", description: "神秘客測試多次，牌義說明具體有據，不用模糊語言敷衍" },
          { _key: "f2", icon: "ri-shield-check-line", title: "無恐嚇無推銷 ✓", description: "測試過程中未出現過度放大負面牌義、或推銷課程/商品的情況" },
          { _key: "f3", icon: "ri-chat-3-line", title: "傾聽能力強 ✓", description: "塔羅師能根據你的提問靈活調整解讀方向，不是死板地執行一套流程" },
        ],
      },
      {
        _type: "cta",
        _key: "cta",
        title: "查看完整塔羅師評比",
        subtitle: "神秘客公正評比台北塔羅工作室，帶你找到最靠譜的解讀師",
        buttonLabel: "查看店家詳情",
        buttonHref: "#",
      },
    ],
    seo: {
      title: "月光塔羅工作室｜台北東區塔羅評比",
      description: "台北東區塔羅評比！10年資歷塔羅師，賦能解讀不恐嚇，全程無推銷。4.7 星 189 則評價。",
      keywords: ["台北塔羅", "塔羅推薦", "占卜諮詢", "身心靈台北"],
    },
  },
];